import React from 'react';

const SeatingManagerSkeleton = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-4">
          <div className="h-8 bg-base-200 rounded skeleton animate-pulse w-40"></div>
          <div className="flex gap-3">
            <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-32"></div>
            <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-24"></div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="lg:col-span-1">
            <div className="card bg-base-100 shadow-sm rounded-2xl p-4">
              <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-3/4 mb-4"></div>
              
              <div className="space-y-3 mb-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="p-3 border border-base-200 rounded-lg">
                    <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-5/6 mb-2"></div>
                    <div className="h-3 bg-base-200 rounded skeleton animate-pulse w-4/6"></div>
                  </div>
                ))}
              </div>
              
              <div className="h-10 bg-base-200 rounded skeleton animate-pulse w-full"></div>
            </div>
          </div>
          
          <div className="lg:col-span-3">
            <div className="card bg-base-100 shadow-sm rounded-2xl p-6">
              <div className="flex justify-between items-center mb-4">
                <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-48"></div>
                <div className="flex gap-2">
                  <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse"></div>
                  <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse"></div>
                </div>
              </div>
              
              <div className="bg-base-200 rounded-lg p-8 min-h-96">
                <div className="grid grid-cols-4 gap-4">
                  {[...Array(20)].map((_, i) => (
                    <div key={i} className="aspect-square bg-base-200 rounded skeleton animate-pulse"></div>
                  ))}
                </div>
              </div>
              
              <div className="mt-4 flex justify-between items-center">
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-32"></div>
                <div className="flex gap-2">
                  <div className="h-8 w-16 bg-base-200 rounded skeleton animate-pulse"></div>
                  <div className="h-8 w-16 bg-base-200 rounded skeleton animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeatingManagerSkeleton;